/**
 * Escapes characters that can not be in an XML element.
 */
function escapeElement(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * @api private
 */
module.exports = {
    escapeElement: escapeElement
};



//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/xml/escape-element.js
// module id = 919
// module chunks = 3